import { FC, useContext } from "react";
import {
	AttributeContainerMobile,
	HeaderWrapper,
	LineItemContentDescription,
	LineItemHeaderValue,
	LineItemNumberSkuDescriptionWrapper
} from "components/Common/LineItemGrid/Header/header.styles";
import {
	NewOrderBuildGridDoorStyleColumnHeader,
	NewOrderBuildGridFinishColumnHeader,
	NewOrderBuildGridQuantityColumnHeader
} from "../../../NewOrders/constants.ts";
import { StandardListPriceText, StandardUnitPriceText, UnavailableDataPlaceholderText } from "constants/text.ts";
import { models } from "types/api/viewModels.ts";
import { StandardPricingContainer } from "../LineItemGridStyles.ts";
import { formatPriceWithPrefix } from "utils/string.ts";
import ConfigurationsContext from "context/configurations/ConfigurationsContext.ts";
import { useUserLocation } from "hooks/useUserLocation.ts";

interface HeaderProps {
	item: models["LineItemViewModel"];
	isEditing?: boolean;
	isSpcialModification?: boolean;
}

const Header: FC<HeaderProps> = ({ item, isEditing = false, isSpcialModification = false }) => {
	const { configurationsData } = useContext(ConfigurationsContext);
	const { isOrderDetailsPage } = useUserLocation();

	return (
		<HeaderWrapper data-testid="line-item-grid">
			<div>
				<LineItemNumberSkuDescriptionWrapper>
					{!isEditing && !isSpcialModification && (
						<div data-testid="line-item-grid-line-number">{item?.lineItemNumber}</div>
					)}
					<LineItemHeaderValue>
						<div data-testid="line-item-grid-header">{item?.sku ?? ""}</div>
						<LineItemContentDescription data-testid="line-item-grid-description">
							{item?.description ?? ""}
						</LineItemContentDescription>
					</LineItemHeaderValue>
				</LineItemNumberSkuDescriptionWrapper>
				{isOrderDetailsPage && (
					<AttributeContainerMobile>
						<div>
							<span>{NewOrderBuildGridDoorStyleColumnHeader}</span>
							<span data-testid="line-item-grid-data-door-style">
								{item?.doorStyle ?? UnavailableDataPlaceholderText}
							</span>
						</div>
						<div>
							<span>{NewOrderBuildGridFinishColumnHeader}</span>
							<span data-testid="line-item-grid-data-finish">
								{item?.finish ?? UnavailableDataPlaceholderText}
							</span>
						</div>
						<div>
							<span>{NewOrderBuildGridQuantityColumnHeader}</span>
							<span data-testid="line-item-grid-data-quantity">{item.quantityOrdered}</span>
						</div>
						<div>
							{item.pricing?.netPrice && configurationsData?.featureFlags?.acknowledgementsEnabled ? (
								<StandardPricingContainer>
									<div>{StandardUnitPriceText}</div>
									<div>{formatPriceWithPrefix(item.pricing.netPrice)}</div>
								</StandardPricingContainer>
							) : (
								configurationsData?.featureFlags?.acknowledgementsEnabled && (
									<StandardPricingContainer>
										<div>{StandardListPriceText}</div>
										<div>{formatPriceWithPrefix(item?.pricing?.listPrice)}</div>
									</StandardPricingContainer>
								)
							)}
						</div>
					</AttributeContainerMobile>
				)}
			</div>
		</HeaderWrapper>
	);
};

export default Header;
